<template>
  <div
      class="is-flex is-flex-direction-column is-align-content-center has-text-centered sorting-filter"
      @click="$emit('iconClicked');"
      :class="highlight ? 'highlight': (customHighlight !== '' ? customHighlight : '')"
  >
    <div class="column is-centered is-paddingless">
      <b-icon :icon="icon"></b-icon>
    </div>
    <div class="has-text-grey-light filterLabel">{{ label }}</div>
  </div>
</template>

<script>
export default {
  name: "FilterWithIcon",
  props:{
    icon:{
      type: String,
      default: '',
    },
    label:{
      type: String,
      default: '',
    },
    customHighlight:{
      type: String,
      default: '',
    },
    highlight: {
      type: Boolean,
      default: false,
    }
  },
}
</script>

<style scoped>

</style>